import { useRef, type PointerEvent, type SyntheticEvent } from "react";

const LONG_PRESS_MS = 500;
/** 이만큼 움직이면 길게 누르기가 아니라 드래그(PC 텍스트 선택·스크롤)로 보고 취소 */
const MOVE_TOLERANCE_PX = 8;

/**
 * 길게 누르기(500ms). 포인터가 떠나거나 떼거나 8px 넘게 움직이면 취소(1.9 메시지 복사).
 * onContextMenu 는 터치 포인터일 때만 억제한다 — 마우스 우클릭 복사는 허용(PC 598:222).
 * 반환 핸들러를 요소에 펼친다. disabled면 아무 일도 하지 않는다.
 */
export function useLongPress(onLongPress: () => void, disabled = false) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const start = useRef<{ x: number; y: number } | null>(null);
  const pointerType = useRef<string>("");
  const clear = () => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = null;
    start.current = null;
  };
  return {
    onPointerDown: (e: PointerEvent) => {
      pointerType.current = e.pointerType;
      if (disabled) return;
      clear();
      start.current = { x: e.clientX, y: e.clientY };
      timer.current = setTimeout(() => {
        timer.current = null;
        onLongPress();
      }, LONG_PRESS_MS);
    },
    onPointerMove: (e: PointerEvent) => {
      const s = start.current;
      if (s && Math.hypot(e.clientX - s.x, e.clientY - s.y) > MOVE_TOLERANCE_PX) clear();
    },
    onPointerUp: clear,
    onPointerLeave: clear,
    onPointerCancel: clear,
    onContextMenu: (e: SyntheticEvent) => {
      if (pointerType.current === "touch") e.preventDefault();
    },
  };
}
